export default "__VITE_ASSET__aa58f33f__"